// extracted by mini-css-extract-plugin
export default {"main-grid":"_Y651GP42UNQYyCwnpsw","long":"gPqnhslax0OH7jlRx3ZV","main-content":"yFz4EiPgQTWarrjelxLs","form":"afMsHshK5bU63eH2z1Pt","toggle":"MFmEHXJFUgQmw7grG9dQ"};